import type { QueryClient } from "@tanstack/react-query";

export interface IPrefetchThreadServiceDependencies {
    readonly queryClient: QueryClient;
}

/**
 * Base class for prefetching agent threads
 */
export abstract class BasePrefetchThreadService {
    protected queryClient: QueryClient;

    constructor(dependencies: IPrefetchThreadServiceDependencies) {
        this.queryClient = dependencies.queryClient;
    }

    abstract prefetchThread(payload?: unknown): Promise<void>;
}
